module.exports = {
        srcSet: __webpack_public_path__ + "static/media/key_emergency_mobile-639.3e8ecc28.webp"+" 639w",
        images: [{path: __webpack_public_path__ + "static/media/key_emergency_mobile-639.3e8ecc28.webp",width: 639,height: 447}],
        src: __webpack_public_path__ + "static/media/key_emergency_mobile-639.3e8ecc28.webp",
        toString: function(){return __webpack_public_path__ + "static/media/key_emergency_mobile-639.3e8ecc28.webp"},
        
        width: 639,
        height: 447
      }